import MuiMenu, { MenuProps as MuiMenuProps } from '@mui/material/Menu';
import React from 'react';

export interface MenuProps extends MuiMenuProps {}

export const Menu = (props: MenuProps) => {
  return <MuiMenu {...props} />;
};
